module.exports = __webpack_public_path__ + "static/media/icon_pagination_list_level_3.00c56e66.svg";